import React from 'react'
import { useRouter } from 'next/router'
import Hero from '../../components/CKALandingPage/Hero'
import FeaturedRibbon from '../../components/CKALandingPage/FeaturedRibbon'
import TheDifference from '../../components/CKALandingPage/TheDifference'
import BiblicalPrinciples from '../../components/CKALandingPage/BiblicalPrinciples'
import ChristianClients from '../../components/CKALandingPage/ChristianClients'
import CKABenefits from '../../components/CKALandingPage/CKABenefits'
import AdvisorsSection from '../../components/CKALandingPage/AdvisorsSection'
import SignUp from '../../components/CKALandingPage/SignUp'
import DiscoverCKA from '../../components/CKALandingPage/DiscoverCKA'
import MarketingNavigation from '../../navigation/marketing';
import PageFooter from '../../components/ArticleBlocks/PageFooter'
// Firm reference data
const FIRM_DATA = {
  'edward-jones': {
    hero_title: (
      <>
        Become an Edward Jones Certified Kingdom Advisor<sup style={{fontSize: '0.5em', verticalAlign: 'super'}}>®</sup>
      </>
    ),
    hero_subtext: (
      <>
        <strong>Edward Jones is now the leading CKA<sup style={{fontSize: '0.5em', verticalAlign: 'super'}}>®</sup> firm in the industry.</strong> <br /> <br/> <strong>Costs are 100% reimbursable.</strong> Upon obtaining the CKA<sup style={{fontSize: '0.5em', verticalAlign: 'super'}}>®</sup> designation, EJ will generously provide 100% reimbursement for the associated cost of obtaining and maintaining the CKA<sup style={{fontSize: '0.5em', verticalAlign: 'super'}}>®</sup>.</>
    ),
    get_certified_url: "https://dashboard.kingdomadvisors.com/cka?firm=edward-jones",
    firm_name: "Edward Jones"
  },
  // Add more firms as needed
  default: {
    hero_title: (
      <>
        Join Us Where Faith <br /> Meets Finance & <br /> Become a Certified Kingdom Advisor<sup style={{fontSize: '0.5em', verticalAlign: 'super'}}>®</sup>
      </>
    ),
    hero_subtext: <>Get the designation that&apos;s the gold standard for Christian<br /> financial advisors.</>,
    get_certified_url: "https://dashboard.kingdomadvisors.com/cka"
  }
}

export default function CKALanding() {
    const router = useRouter()
    const { firm } = router.query
    
    
    // Get firm data or default
    const firmData = FIRM_DATA[firm] || FIRM_DATA.default

    return (
        <MarketingNavigation>
            <div className='w-full h-full '>
                <Hero firmData={firmData} />
                <FeaturedRibbon />
                <TheDifference firmData={firmData} />
                <DiscoverCKA />
                <CKABenefits />
                <AdvisorsSection />
                <BiblicalPrinciples />
                <ChristianClients firmData={firmData} />
                <SignUp firmData={firmData} />
                <PageFooter />
            </div>
        </MarketingNavigation>
    )
}

CKALanding.isPublic = true;
CKALanding.getLayout = (page) => <>{page}</>;